import { render, staticRenderFns } from "./RegistrarProducto.vue?vue&type=template&id=5ec44ebe&scoped=true&"
import script from "./RegistrarProducto.vue?vue&type=script&lang=js&"
export * from "./RegistrarProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec44ebe",
  null
  
)

export default component.exports